export enum CashRegisterStatus {
  Closed = 'closed',
  Resolved = 'resolved',
  Incidence = 'incidence',
}
